export default __webpack_public_path__ + "static/media/image-main-1-w.d881bb20.webp";